import { useGetCampaigns } from "../../../../../hooks/api/queries/useLoyalty";

const useAllCampaigns = () => {
  const { isLoading, data } = useGetCampaigns({ queries: "" });

  return { isLoading, campaigns: data?.data };
};
export default useAllCampaigns;
